var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectAllCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M-.566-3.191a.434.434,0,0,1-.618,0l-1.75-1.75a.434.434,0,0,1,0-.618.434.434,0,0,1,.618,0L-.875-4.118,2.316-7.309a.434.434,0,0,1,.618,0,.434.434,0,0,1,0,.618ZM7-5.25a7,7,0,0,1-7,7,7,7,0,0,1-7-7,7,7,0,0,1,7-7A7,7,0,0,1,7-5.25ZM0-11.375A6.125,6.125,0,0,0-6.125-5.25,6.125,6.125,0,0,0,0,.875,6.125,6.125,0,0,0,6.125-5.25,6.125,6.125,0,0,0,0-11.375Z",
    transform: "translate(7 12.25)",
    fill: "#181f38",
    opacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectAllCheck);
export default __webpack_public_path__ + "static/media/selectAllCheck.47698909c7ceb26ec93ffad1c6dbc818.svg";
export { ForwardRef as ReactComponent };